import React from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import Avatar from '@/components/common/Avatar'
import styled from 'styled-components'
import ButtonSmall from '../form/ButtonSmall'
import { Auth } from 'aws-amplify'


const SideMenu: React.FC = () => {
    const { pathname } = useLocation()

    const links = [
        { path: '/dashboard', text: 'ダッシュボード' },
        { path: '/authors', text: '著者名一覧' },
        { path: '/books', text: '書籍一覧' },
        { path: '/reports', text: 'レポート' },
        { path: '/revenue', text: '収益の受け取り' },
        { path: '/announcement', text: 'お知らせ' },
    ]
    
    return (
        <Container>
            <Column>
                <Avatar />
                {links.map((link) => (
                    <LinkItem data-side-menu={link.text} data-active={pathname === link.path ? true : null} to={link.path} key={link.path}>
                        {link.text}
                    </LinkItem>
                ))}
            </Column>
        </Container>
    )
}

export default SideMenu

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
`

const Column = styled.div`
    display: flex;
    flex-direction: column;
`

const LinkItem = styled(Link)`
    height: 64px;
    line-height: 64px;
    border-bottom: 1px solid #c7c7c7;
    text-decoration: none;
    padding-left: 15px;
    font-size: 14px;
    box-sizing: border-box;
    color: ${(p) => p.theme.colors.fore};

    &:hover {
        background-color: #eee;
    }

    &[data-active] {
        background-color: ${(p) => p.theme.colors.bgMain};
        font-weight: bold;
    }
`

const LogoutButton = styled(ButtonSmall)`
    margin: 60px 20px 20px;
`;